import styled from "styled-components";

// Estilos da tela de edição de seletiva (abas "Dados" e "Projetos").

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
`;

export const Tabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.gray3};
`;

export const Tab = styled.button`
  background: transparent;
  border: none;
  border-bottom: 3px solid
    ${({ theme, $active }) =>
      $active ? theme.colors.primary.vividCerulean : "transparent"};
  margin-bottom: -1px;
  padding: 12px 20px;
  cursor: pointer;
  transition: 0.2s;
  ${({ theme }) => theme.font.body.md}
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.neutral.black : theme.colors.neutral.gray6};

  &:hover {
    color: ${({ theme }) => theme.colors.neutral.black};
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
`;
